/*  ========================================================================
    # Scripts - Sticky CTA Bar
    ========================================================================  */

/**
 * Shows the "Sticky CTA Bar" if the element is not intersecting and the is not
 * above the scrollwindow.
 */
const StickyCtaBar = {
  cfg: {
    body: document.body,
    formCtaSection: document.querySelector('.s-form-cta'),
    stickyCtaBar: document.getElementById('s-form-cta__bar')
  },

  handleStickyCtaBar() {
    const observer = new IntersectionObserver(elements => {
      elements.forEach(element => {
        if (!element.isIntersecting && element.boundingClientRect.y > 0) {
          this.cfg.stickyCtaBar.classList.add('s-form-cta__bar--show');
        } else {
          this.cfg.stickyCtaBar.classList.remove('s-form-cta__bar--show');
        }
      });
    });

    if (this.cfg.formCtaSection) observer.observe(this.cfg.formCtaSection);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.stickyCtaBar !== undefined && this.cfg.stickyCtaBar !== null) {
      this.handleStickyCtaBar();
    }
  }
};

export default StickyCtaBar;
